const dataLayer = window.dataLayer || [];
function dataTrackingPrivacyPolicy() {
  const links = document.querySelectorAll('.request-form-link')
  if (links) {
      links.forEach(link => {
          link.addEventListener("click", fireTrackingEvent,false)
      });
  }
}

function fireTrackingEvent(e) {
  dataLayer.push({
      "data-elCat": e.target.dataset.elcat,
      "data-elAct": e.target.dataset.elact,
      "data_elLab": e.target.dataset.ellab,
      "data-elLoc": e.target.dataset.elloc
  });
}

export default dataTrackingPrivacyPolicy;